var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQuest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2140_582)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C9.62663 24 7.30655 23.2962 5.33316 21.9776C3.35977 20.6591 1.8217 18.7849 0.913451 16.5922C0.00519943 14.3995 -0.232441 11.9867 0.230582 9.65892C0.693605 7.33115 1.83649 5.19295 3.51472 3.51472C5.19295 1.83649 7.33115 0.693605 9.65892 0.230582C11.9867 -0.232441 14.3995 0.00519943 16.5922 0.913451C18.7849 1.8217 20.6591 3.35977 21.9776 5.33316C23.2962 7.30655 24 9.62663 24 12C23.9966 15.1815 22.7312 18.2318 20.4815 20.4815C18.2318 22.7312 15.1815 23.9966 12 24ZM12 2.00001C10.0222 2.00001 8.08879 2.5865 6.4443 3.68531C4.79981 4.78412 3.51809 6.34591 2.76121 8.17317C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C21.9971 9.34873 20.9426 6.80689 19.0679 4.93215C17.1931 3.05742 14.6513 2.00292 12 2.00001Z",
    fill: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 16.9998H11V18.9998H13V16.9998Z",
    fill: "#5C5C5C"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9993 5C10.939 5.00099 9.92233 5.3964 9.17254 6.09945C8.42275 6.80249 8.00106 7.75574 8 8.75H9.3331C9.3331 8.08696 9.61401 7.45107 10.114 6.98223C10.614 6.51339 11.2922 6.25 11.9993 6.25C12.6397 6.24941 13.2589 6.46497 13.7438 6.85727C14.2286 7.24957 14.5467 7.7924 14.6398 8.3865C14.7329 8.9806 14.5949 9.58628 14.2509 10.0928C13.9069 10.5993 13.38 10.9728 12.7665 11.145C12.3527 11.2579 11.9892 11.4937 11.7307 11.817C11.4721 12.1402 11.3325 12.5334 11.3328 12.9375V15H12.6659V12.9375C12.6671 12.8025 12.7149 12.6716 12.8022 12.5642C12.8894 12.4569 13.0113 12.3789 13.1498 12.3419C14.0695 12.0832 14.8592 11.5229 15.3747 10.7633C15.8902 10.0037 16.0971 9.09563 15.9575 8.20486C15.8179 7.3141 15.3412 6.50015 14.6145 5.91173C13.8877 5.32331 12.9595 4.99969 11.9993 5Z",
    fill: "#5C5C5C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2140_582"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuest);
export default __webpack_public_path__ + "static/media/iconQuest.98d79a7a.svg";
export { ForwardRef as ReactComponent };